import React from "react"




const Spinner = () => {
    return (
        <div className="fr-flex fr-justify-center fr-items-center">
            <div className="fr-spinner-crescent"></div>
        </div>
    )
}

export default Spinner